import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import LoginForm from './components/LoginForm';
import PlatformUpdates from './components/PlatformUpdates';

const UserLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Mock user credentials for demonstration
  const mockCredentials = {
    email: 'developer@selenium.com',
    password: 'selenium123'
  };

  useEffect(() => {
    // Enhanced authentication check - redirect to dashboard if already logged in
    const checkExistingAuth = () => {
      const token = localStorage.getItem('authToken');
      const userData = localStorage.getItem('userData');
      const rememberMe = localStorage.getItem('rememberMe') === 'true';
      const loginTime = localStorage.getItem('loginTime');
      
      if (token && userData) {
        const currentTime = Date.now();
        const sessionDuration = 24 * 60 * 60 * 1000; // 24 hours
        
        if (rememberMe || (loginTime && (currentTime - parseInt(loginTime)) < sessionDuration)) {
          navigate('/mission-map-dashboard');
        } else {
          // Clear expired session
          localStorage.removeItem('authToken');
          localStorage.removeItem('userData');
          localStorage.removeItem('rememberMe');
          localStorage.removeItem('loginTime');
        }
      }
    };

    checkExistingAuth();
  }, [navigate]);

  // Enhanced login handler with persistent session management
  const handleLogin = async (formData) => {
    setIsLoading(true);
    setError('');

    try {
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1500));

      // Mock authentication validation
      if (formData?.email === mockCredentials?.email && formData?.password === mockCredentials?.password) {
        // Mock successful login
        const mockToken = 'mock-jwt-token-' + Date.now();
        const mockUser = {
          id: 1,
          username: 'SeleniumDev',
          email: formData?.email,
          level: 3,
          levelTitle: 'Automation Specialist',
          currentXP: 1250,
          nextLevelXP: 2000,
          completedMissions: 12,
          totalScore: 2450
        };

        const currentTime = Date.now();

        // Enhanced authentication data storage
        localStorage.setItem('authToken', mockToken);
        localStorage.setItem('userData', JSON.stringify(mockUser));
        localStorage.setItem('loginTime', currentTime?.toString());
        
        if (formData?.rememberMe) {
          localStorage.setItem('rememberMe', 'true');
        } else {
          localStorage.removeItem('rememberMe');
        }

        // Clean up any old authentication data
        localStorage.removeItem('currentUser'); // Legacy cleanup

        // Navigate to dashboard instead of mission map for better UX
        navigate('/mission-map-dashboard');
      } else {
        // Enhanced error message
        setError(`Invalid credentials. Please check your email and password.`);
      }
    } catch (err) {
      setError('Login failed. Please check your connection and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="content-offset min-h-screen flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
            {/* Login Form Section */}
            <div className="flex justify-center lg:justify-end">
              <LoginForm 
                onLogin={handleLogin}
                isLoading={isLoading}
                error={error}
                mockCredentials={mockCredentials} // Pass mock credentials for demo
              />
            </div>

            {/* Platform Updates Section */}
            <div className="flex justify-center lg:justify-start">
              <PlatformUpdates />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserLogin;